import {
  USER_DETAIL, USER_DETAIL_FAILURE, USER_DETAIL_SUCCESS
} from './mutation-types'

export default {
  state: {
    user: null,
    turnoverTypes: null,
    shopHistories: null,
    shops: null,
    usertypeHistories: null,
    userTypes: null,
    userDetailLoading: true,
    userServiceQuestionId: null,
    userServiceQuestionAnswerStartDate: null
  },
  getters: {
    userDetail: state => {
      return state.user
    },
    turnoverDetail: state => {
      return state.turnoverTypes
    },
    shopHistoryDetail: state => {
      return state.shopHistories
    },
    usertypeHistoryDetail: state => {
      return state.usertypeHistories
    },
    usertypeDetail: state => {
      return state.userTypes
    },
    usershopDetail: state => {
      return state.shops
    },
    userServiceQuestionId: state => {
      return state.userServiceQuestionId
    },
    userServiceQuestionAnswerStartDate: state => {
      return state.userServiceQuestionAnswerStartDate
    }
  },
  actions: {
    [USER_DETAIL] ({dispatch, state, commit}, params) {
      var url = '/master/users/' + params.id
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_DETAIL_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(USER_DETAIL_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USER_DETAIL_FAILURE] (state, data) {
      console.log('USER_DETAIL_FAILURE')
    },
    [USER_DETAIL_SUCCESS] (state, data) {
      console.log('USER_DETAIL_SUCCESS')
      state.user = data.user.data[0]
      state.shopHistories = data.shophistories.data
      state.usertypeHistories = data.usertypehistories.data
      state.turnoverTypes = data.turnover_types.data
      state.userTypes = data.user_types.data
      state.shops = data.shops.data
      state.userServiceQuestionId = data.service_question_id
      state.userServiceQuestionAnswerStartDate = data.service_question_answer_start_date
      data.callback()
      state.userDetailLoading = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user-detail.js